import {
  SET_FORECAST_GWC,
} from "./mutations";
import ForecastedGWC from "../../../models/valuation/ForecastedGWC";
import {store} from "../../index";
import { generateForecastedRevenue } from "../valuation/actions";

export const updateForecastedGWC = ({ nonCashWorkingCapitalPercentageRevenue, analystNote }) => (dispatch) => {
  const storedForecastedGWC = store.getState().forecastGWC.currentForecastGWC

  if (nonCashWorkingCapitalPercentageRevenue) {
    storedForecastedGWC.nonCashWorkingCapitalPercentageRevenue = nonCashWorkingCapitalPercentageRevenue
  }
  if (analystNote || analystNote === "") storedForecastedGWC.analystNote = analystNote

  dispatch({ type: SET_FORECAST_GWC, payload: new ForecastedGWC({
      ...storedForecastedGWC
  })})
}

export const generateForecastedGWC = (options = { clearCache: false }) => (dispatch) => {
  dispatch(generateForecastedRevenue())

  const { forecastGWC , taxes } = store.getState()
  const { forecastedRevenue } = store.getState().valuation;
  const storedForecastedGWC = forecastGWC.currentForecastGWC
  const growthRate = 1 + (taxes.growthRate / 100)

  if (storedForecastedGWC && !options.clearCache) {
    dispatch({ type: SET_FORECAST_GWC, payload: new ForecastedGWC({
        ...storedForecastedGWC,
        forecastRevenue: forecastedRevenue?.forecastedValue,
        growthRate: growthRate
      })})

    return
  }

  dispatch({ type: SET_FORECAST_GWC, payload: new ForecastedGWC({
    forecastRevenue: forecastedRevenue?.forecastedValue,
    growthRate: growthRate
  })})
}